import { HotelAmenitiesService } from "booking_app/services/hotels/hotel-amenities.service";

export class AmenitiesController {
  static $inject = ["$scope", "$rootScope", "HotelAmenitiesService"];

  private hotelDetail: any;

  constructor(
    private $scope: any,
    private $rootScope: any,
    private hotelAmenitiesService: HotelAmenitiesService,
  ) {
  }

  hasGuestLove(): boolean {
    return this.hotelAmenitiesService.hasGuestLove(this.hotelDetail);
  }

  guestLoveList(): string[] {
    return this.hotelAmenitiesService.guestLoveList(this.hotelDetail);
  }

  hasAmenities(): boolean {
    return this.hotelAmenitiesService.hasAmenities(this.hotelDetail);
  }

}
